import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-error p-ml-2",
  "data-test": "error-message"
}
const _hoisted_2 = { class: "p-d-flex kn-flex kn-overflow" }
const _hoisted_3 = {
  id: "list-container",
  class: "p-d-flex p-ml-2",
  style: {"flex":"1 1 0"}
}
const _hoisted_4 = { class: "kn-list-item" }
const _hoisted_5 = { class: "kn-list-item-text" }
const _hoisted_6 = {
  id: "button-container",
  class: "p-as-center p-mx-2"
}
const _hoisted_7 = { class: "p-d-flex p-flex-column" }
const _hoisted_8 = {
  id: "identifier-container",
  class: "p-d-flex p-mr-2",
  style: {"flex":"1 1 0"}
}
const _hoisted_9 = { class: "kn-list-item" }
const _hoisted_10 = { class: "p-d-flex p-flex-row kn-flex" }
const _hoisted_11 = { class: "p-ml-auto" }
const _hoisted_12 = {
  id: "recursive-container",
  class: "p-m-2"
}
const _hoisted_13 = {
  key: 0,
  class: "p-ml-2"
}
const _hoisted_14 = { class: "marginated-form p-fluid p-formgrid p-grid" }
const _hoisted_15 = { class: "p-field p-col-6" }
const _hoisted_16 = { class: "p-float-label" }
const _hoisted_17 = { class: "kn-material-input-label" }
const _hoisted_18 = { class: "p-field p-col-6" }
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_Dropdown = _resolveComponent("Dropdown")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.errorMessageVisible)
      ? (_openBlock(), _createBlock("small", _hoisted_1, _toDisplayString(_ctx.$t('managers.hierarchyManagement.createHierarchyMasterErrorMessage')), 1))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_Listbox, {
          class: "kn-list kn-list-border-all kn-flex hierarchy-management-list",
          listStyle: "max-height:calc(100% - 62px)",
          modelValue: _ctx.selectedSourceFields,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedSourceFields = $event)),
          options: _ctx.dimensionSourceFields,
          optionLabel: "NAME",
          multiple: true,
          filter: true,
          onChange: _ctx.onSelectedField
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode("span", {
                  "data-test": 'list-item-' + slotProps.option.NAME
                }, _toDisplayString(slotProps.option.NAME), 9, ["data-test"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options", "onChange"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary hierarchy-management-master-selecet-list-button",
            icon: "pi pi-angle-double-right",
            disabled: _ctx.selectedSourceFields.length === 0,
            onClick: _ctx.moveToTheRight,
            "data-test": "move-right-button"
          }, null, 8, ["disabled", "onClick"]),
          _createVNode(_component_Button, {
            class: "kn-button kn-button--primary hierarchy-management-master-selecet-list-button p-mt-2",
            icon: "pi pi-angle-double-left",
            disabled: _ctx.selectedDestinationFields.length === 0,
            onClick: _ctx.moveToTheLeft
          }, null, 8, ["disabled", "onClick"])
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_Listbox, {
          class: "kn-list kn-list-border-all kn-flex hierarchy-management-list",
          listStyle: "max-height:100%",
          modelValue: _ctx.selectedDestinationFields,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedDestinationFields = $event)),
          options: _ctx.dimensionDestinationFields,
          optionLabel: "NAME",
          multiple: true,
          onChange: _ctx.onSelectedField,
          "data-test": "selected-destinations-list"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          option: _withCtx((slotProps) => [
            _createVNode("div", _hoisted_9, [
              _createVNode("div", _hoisted_10, [
                _createVNode("span", null, [
                  _createVNode("b", null, _toDisplayString(_ctx.$t('managers.hierarchyManagement.lev') + ' ' + slotProps.option.code.level + ' '), 1),
                  _createTextVNode(" " + _toDisplayString(slotProps.option.code.NAME + ', ' + slotProps.option.name.NAME), 1)
                ]),
                _createVNode("div", _hoisted_11, [
                  (slotProps.index === _ctx.dimensionDestinationFields.length - 1)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        icon: "fa fa-plus",
                        class: "p-button-text p-button-plain p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.moveToRecursive(slotProps.option, slotProps.index)), ["stop"]),
                        "data-test": 'recursive-button-' + slotProps.option.code.NAME
                      }, null, 8, ["onClick", "data-test"]))
                    : _createCommentVNode("", true),
                  (slotProps.index !== 0)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        icon: "fa fa-arrow-up",
                        class: "p-button-text p-button-plain p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.move(slotProps.option, slotProps.index, 'up')), ["stop"])
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (slotProps.index !== _ctx.dimensionDestinationFields.length - 1)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        icon: "fa fa-arrow-down",
                        class: "p-button-text p-button-plain p-button-sm p-p-0",
                        onClick: _withModifiers(($event: any) => (_ctx.move(slotProps.option, slotProps.index, 'down')), ["stop"])
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "options", "onChange"])
      ])
    ]),
    _createVNode("div", _hoisted_12, [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0 p-col-12" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('managers.hierarchyManagement.recursive') + ': ') + " ", 1),
          (_ctx.recursive)
            ? (_openBlock(), _createBlock("span", _hoisted_13, _toDisplayString(_ctx.recursive.code.NAME + ' ' + _ctx.recursive.name.NAME), 1))
            : _createCommentVNode("", true)
        ]),
        end: _withCtx(() => [
          _withDirectives(_createVNode(_component_Button, {
            icon: "pi pi-trash",
            class: "p-button-text p-button-rounded p-button-plain",
            onClick: _ctx.removeRecursive
          }, null, 8, ["onClick"]), [
            [_vShow, _ctx.recursive]
          ])
        ]),
        _: 1
      }),
      _createVNode("form", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("span", _hoisted_16, [
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.recursiveParentName,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.recursiveParentName = $event)),
              options: _ctx.parentDimensionSourceFields,
              optionLabel: "NAME",
              disabled: !_ctx.recursive,
              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('recursiveChanged', { recursive: _ctx.recursive, recursiveParentName: _ctx.recursiveParentName, recursiveParentDescription: _ctx.recursiveParentDescription })))
            }, null, 8, ["modelValue", "options", "disabled"]),
            _createVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('common.name')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_18, [
          _createVNode("span", _hoisted_19, [
            _createVNode(_component_Dropdown, {
              class: "kn-material-input",
              modelValue: _ctx.recursiveParentDescription,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.recursiveParentDescription = $event)),
              options: _ctx.parentDimensionSourceFields,
              optionLabel: "NAME",
              disabled: !_ctx.recursive,
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('recursiveChanged', { recursive: _ctx.recursive, recursiveParentName: _ctx.recursiveParentName, recursiveParentDescription: _ctx.recursiveParentDescription })))
            }, null, 8, ["modelValue", "options", "disabled"]),
            _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.description')), 1)
          ])
        ])
      ])
    ])
  ], 64))
}